(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colorflow-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.cfInit) return;
      root.dataset.cfInit = '1';

      root.querySelectorAll('[data-cf-viewer]').forEach(function (viewer) {
        var after = viewer.querySelector('.cf-after');
        var handle = viewer.querySelector('.cf-handle');
        if (!after || !handle) return;
        var dragging = false;
        function setSplit(clientX) {
          var r = viewer.getBoundingClientRect();
          var p = ((clientX - r.left) / r.width) * 100;
          p = Math.max(2, Math.min(98, p));
          after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
          handle.style.left = p + '%';
        }
        function down(e) { dragging = true; setSplit((e.touches ? e.touches[0] : e).clientX); }
        function move(e) { if (dragging) setSplit((e.touches ? e.touches[0] : e).clientX); }
        viewer.addEventListener('mousedown', down);
        viewer.addEventListener('touchstart', down, { passive: true });
        window.addEventListener('mousemove', move);
        window.addEventListener('touchmove', move, { passive: true });
        window.addEventListener('mouseup', function () { dragging = false; });
        window.addEventListener('touchend', function () { dragging = false; });
      });

      var chips = Array.prototype.slice.call(root.querySelectorAll('.cf-chip'));
      var lookBase = root.querySelector('[data-cf-lookbase]');
      var lookName = root.querySelector('[data-cf-lookname]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          if (lookBase) {
            lookBase.classList.add('is-swapping');
            lookBase.style.opacity = '0';
            setTimeout(function () {
              lookBase.style.filter = chip.getAttribute('data-filter');
              lookBase.src = chip.getAttribute('data-img');
              lookBase.style.opacity = '1';
              setTimeout(function () { lookBase.classList.remove('is-swapping'); }, 280);
            }, 160);
          }
          if (lookName) lookName.textContent = chip.getAttribute('data-name');
        });
      });

      var dataEl = root.querySelector('.cf-steps');
      var frameA = root.querySelector('[data-cf-frame-a]');
      if (dataEl && frameA) {
        var STEPS = [];
        try { STEPS = JSON.parse(dataEl.textContent); } catch (e) { STEPS = []; }
        var frameB = root.querySelector('[data-cf-frame-b]');
        var uiA = root.querySelector('[data-cf-ui-a]');
        var uiB = root.querySelector('[data-cf-ui-b]');
        var framePair = { a: frameA, b: frameB, front: frameA };
        var uiPair = { a: uiA, b: uiB, front: uiA };
        var tagEl = root.querySelector('[data-cf-tag]');
        var uilabelEl = root.querySelector('[data-cf-uilabel]');
        var titleEl = root.querySelector('[data-cf-title]');
        var descEl = root.querySelector('[data-cf-desc]');
        var countEl = root.querySelector('[data-cf-count]');
        var progressEl = root.querySelector('.cf-wz-progress');
        var viewerEl = root.querySelector('.cf-sv');
        var steps = Array.prototype.slice.call(root.querySelectorAll('.cf-wz'));
        var prevBtn = root.querySelector('[data-cf-prev]');
        var nextBtn = root.querySelector('[data-cf-next]');
        var cur = 0;
        var last = STEPS.length - 1;

        function crossfade(pair, src) {
          var front = pair.front;
          var back = pair.front === pair.a ? pair.b : pair.a;
          if (back.getAttribute('src') === src && back.style.opacity === '1') return;
          back.onload = function () { back.style.opacity = '1'; front.style.opacity = '0'; pair.front = back; };
          if (back.getAttribute('src') === src) { back.onload(); } else { back.src = src; }
        }

        function goStep(i) {
          if (last < 0) return;
          cur = Math.max(0, Math.min(last, i));
          var s = STEPS[cur];
          crossfade(framePair, s.frame);
          crossfade(uiPair, s.ui);
          if (tagEl) { tagEl.textContent = s.tag; }
          if (uilabelEl) uilabelEl.textContent = s.uilabel;
          if (titleEl) titleEl.textContent = s.title;
          if (descEl) descEl.innerHTML = s.desc;
          if (countEl) countEl.textContent = 'Step ' + (cur + 1) + ' of ' + STEPS.length;
          if (progressEl) progressEl.style.width = (cur / last * 75) + '%';
          steps.forEach(function (t, idx) {
            t.classList.toggle('is-active', idx === cur);
            t.classList.toggle('is-done', idx < cur);
            var dot = t.querySelector('.cf-wz-dot');
            if (dot) dot.textContent = idx < cur ? '✓' : String(idx + 1);
          });
          if (prevBtn) prevBtn.disabled = cur === 0;
          if (nextBtn) nextBtn.innerHTML = cur === last ? 'Start over &#8635;' : 'Next step &rarr;';
        }

        steps.forEach(function (t, idx) { t.addEventListener('click', function () { goStep(idx); }); });
        if (prevBtn) prevBtn.addEventListener('click', function () { goStep(cur - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goStep(cur === last ? 0 : cur + 1); });
        if (viewerEl) viewerEl.addEventListener('click', function () { goStep(cur === last ? 0 : cur + 1); });
      }

      root.classList.add('cf-anim');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cf-in'); io.unobserve(e.target); } });
        }, { threshold: 0.12 });
        root.querySelectorAll('.cf-reveal').forEach(function (el) { io.observe(el); });
      } else {
        root.querySelectorAll('.cf-reveal').forEach(function (el) { el.classList.add('cf-in'); });
      }

      var buybar = root.querySelector('.cf-buybar');
      var heroEl = root.querySelector('.cf-hero');
      if (buybar && heroEl && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { buybar.classList.toggle('is-shown', !e.isIntersecting); });
        }, { threshold: 0 }).observe(heroEl);
      }
    }

    function initAll() { document.querySelectorAll('.cf').forEach(initRoot); }
    if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorflow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.cfInit) return;
      root.dataset.cfInit = '1';

      root.querySelectorAll('[data-cf-viewer]').forEach(function (viewer) {
        var after = viewer.querySelector('.cf-after');
        var handle = viewer.querySelector('.cf-handle');
        if (!after || !handle) return;
        var dragging = false;
        function setSplit(clientX) {
          var r = viewer.getBoundingClientRect();
          var p = ((clientX - r.left) / r.width) * 100;
          p = Math.max(2, Math.min(98, p));
          after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
          handle.style.left = p + '%';
        }
        function down(e) { dragging = true; setSplit((e.touches ? e.touches[0] : e).clientX); }
        function move(e) { if (dragging) setSplit((e.touches ? e.touches[0] : e).clientX); }
        viewer.addEventListener('mousedown', down);
        viewer.addEventListener('touchstart', down, { passive: true });
        window.addEventListener('mousemove', move);
        window.addEventListener('touchmove', move, { passive: true });
        window.addEventListener('mouseup', function () { dragging = false; });
        window.addEventListener('touchend', function () { dragging = false; });
      });

      var chips = Array.prototype.slice.call(root.querySelectorAll('.cf-chip'));
      var lookBase = root.querySelector('[data-cf-lookbase]');
      var lookName = root.querySelector('[data-cf-lookname]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          if (lookBase) {
            lookBase.style.opacity = '0';
            setTimeout(function () {
              lookBase.style.filter = chip.getAttribute('data-filter');
              lookBase.src = chip.getAttribute('data-img');
              lookBase.style.opacity = '1';
            }, 160);
          }
          if (lookName) lookName.textContent = chip.getAttribute('data-name');
        });
      });

      var dataEl = root.querySelector('.cf-steps');
      var frameA = root.querySelector('[data-cf-frame-a]');
      if (dataEl && frameA) {
        var STEPS = [];
        try { STEPS = JSON.parse(dataEl.textContent); } catch (e) { STEPS = []; }
        var frameB = root.querySelector('[data-cf-frame-b]');
        var uiA = root.querySelector('[data-cf-ui-a]');
        var uiB = root.querySelector('[data-cf-ui-b]');
        var framePair = { a: frameA, b: frameB, front: frameA };
        var uiPair = { a: uiA, b: uiB, front: uiA };
        var tagEl = root.querySelector('[data-cf-tag]');
        var uilabelEl = root.querySelector('[data-cf-uilabel]');
        var titleEl = root.querySelector('[data-cf-title]');
        var descEl = root.querySelector('[data-cf-desc]');
        var countEl = root.querySelector('[data-cf-count]');
        var progressEl = root.querySelector('.cf-wz-progress');
        var viewerEl = root.querySelector('.cf-sv');
        var steps = Array.prototype.slice.call(root.querySelectorAll('.cf-wz'));
        var prevBtn = root.querySelector('[data-cf-prev]');
        var nextBtn = root.querySelector('[data-cf-next]');
        var cur = 0;
        var last = STEPS.length - 1;

        function crossfade(pair, src) {
          var front = pair.front;
          var back = pair.front === pair.a ? pair.b : pair.a;
          if (back.getAttribute('src') === src && back.style.opacity === '1') return;
          back.onload = function () { back.style.opacity = '1'; front.style.opacity = '0'; pair.front = back; };
          if (back.getAttribute('src') === src) { back.onload(); } else { back.src = src; }
        }

        function goStep(i) {
          if (last < 0) return;
          cur = Math.max(0, Math.min(last, i));
          var s = STEPS[cur];
          crossfade(framePair, s.frame);
          crossfade(uiPair, s.ui);
          if (tagEl) { tagEl.textContent = s.tag; }
          if (uilabelEl) uilabelEl.textContent = s.uilabel;
          if (titleEl) titleEl.textContent = s.title;
          if (descEl) descEl.innerHTML = s.desc;
          if (countEl) countEl.textContent = 'Step ' + (cur + 1) + ' of ' + STEPS.length;
          if (progressEl) progressEl.style.width = (cur / last * 75) + '%';
          steps.forEach(function (t, idx) {
            t.classList.toggle('is-active', idx === cur);
            t.classList.toggle('is-done', idx < cur);
            var dot = t.querySelector('.cf-wz-dot');
            if (dot) dot.textContent = idx < cur ? '✓' : String(idx + 1);
          });
          if (prevBtn) prevBtn.disabled = cur === 0;
          if (nextBtn) nextBtn.innerHTML = cur === last ? 'Start over &#8635;' : 'Next step &rarr;';
        }

        steps.forEach(function (t, idx) { t.addEventListener('click', function () { goStep(idx); }); });
        if (prevBtn) prevBtn.addEventListener('click', function () { goStep(cur - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goStep(cur === last ? 0 : cur + 1); });
        if (viewerEl) viewerEl.addEventListener('click', function () { goStep(cur === last ? 0 : cur + 1); });
      }

      root.classList.add('cf-anim');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cf-in'); io.unobserve(e.target); } });
        }, { threshold: 0.12 });
        root.querySelectorAll('.cf-reveal').forEach(function (el) { io.observe(el); });
      } else {
        root.querySelectorAll('.cf-reveal').forEach(function (el) { el.classList.add('cf-in'); });
      }
    }

    function initAll() { document.querySelectorAll('.cf').forEach(initRoot); }
    if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
